import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import UsersService, { BOAPI } from "../service/UsersService";

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    const loadUser = async () => {
      let user = UsersService.users?.find(u => u.id === Number(id));

      if (!user) {
        const resp = await BOAPI.fetchUsers();
        user = resp?.[1]?.find(u => u.id === Number(id));
      }

      setUser(user);

      try {
        const res = await BOAPI.fetchUserActivities(id);
        
        if (res && res[1]) {
          setActivities(res[1]); 
        } else if (Array.isArray(res)) {
          setActivities(res);
        }
      } catch (err) {
        console.error("Error fetching activities:", err);
      }
    };

    loadUser();
  }, [id]);

  // פונקציית עזר לחלוקת הפעילויות לפי ימים
  const groupActivitiesByDay = (items) => {
    const groups = {};
    
    items.forEach(act => {
      if (!act.iTime) return;
      
      // תחלץ רק את חלק התאריך (10 התווים הראשונים: YYYY-MM-DD)
      const dateString = act.iTime.substring(0, 10);
      const [year, month, day] = dateString.split('-');
      
      // צור תאריך בלי להיכנס לבעיות של טיימזון
      const dateObj = new Date(year, month - 1, day);
      
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      let dayLabel = dateObj.toLocaleDateString("he-IL", { day: "numeric", month: "long", year: "numeric" });
      
      if (dateObj.toDateString() === today.toDateString()) {
        dayLabel = "היום";
      } else if (dateObj.toDateString() === yesterday.toDateString()) {
        dayLabel = "אתמול";
      }
      
      if (!groups[dayLabel]) {
        groups[dayLabel] = [];
      }
      groups[dayLabel].push(act);
    });
    
    return groups;
  };

  // פונקציה להצגת ה-extraData בצורה יפה
  const renderExtraData = (jsonData) => {
    try {
      if (!jsonData) return null;
      const data = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
      return (
        <div style={styles.timelineExtra}>
          {Object.entries(data).map(([key, val]) => (
            <span key={key} style={{ marginLeft: "12px" }}>
              <strong>{key}:</strong> {String(val)}
            </span>
          ))}
        </div>
      );
    } catch (e) {
      return <div style={styles.timelineExtra}>{jsonData}</div>;
    }
  };

  if (!user) {
    return <div style={styles.center}>טוען...</div>;
  }

  const groupedActivities = groupActivitiesByDay(activities);

  return (
    <div style={styles.page}>
      
      <button style={styles.backBtn} onClick={() => navigate(-1)}>
        ← חזרה
      </button>

      {/* כרטיס פרופיל */}
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.avatar}>
            {user.fName?.[0]}{user.lName?.[0]}
          </div>
          <div>
            <h2 style={styles.name}>
              {user.fName} {user.lName}
            </h2>
            <p style={styles.username}>@{user.username}</p>
          </div>
        </div>

        <div style={styles.grid}>
          <Info label="ID" value={user.id} />
          <Info label="אימייל" value={user.email || "-"} />
          <Info label="טלפון" value={user.phone || "-"} />
          <Info label="תפקיד" value={user.role} />
          <Info label="סטטוס" value={user.isActive ? "פעיל" : "לא פעיל"} />
          <Info label="תאריך הרשמה" value={user.iTime} />
          <Info label="נקודות" value={user.point} />
          <Info label="מגדר" value={user.gender || "-"} />
        </div>
      </div>

      {/* אזור פעילויות מעוצב ומחולק לפי ימים */}
      <div style={{ ...styles.card, marginTop: "2rem" }}>
        <h3 style={{ marginBottom: "2rem", color: "#1a1f36", fontSize: "18px" }}>ציר זמן פעילות</h3>
        
        {Object.keys(groupedActivities).length === 0 ? (
          <div style={{ color: "#888", fontSize: "14px", textAlign: "center", padding: "1rem" }}>
            אין פעילויות להצגה בשבוע האחרון.
          </div>
        ) : (
          <div>
            {Object.entries(groupedActivities).map(([day, dayActs]) => (
              <div key={day} style={{ marginBottom: "1.5rem" }}>
                {/* כותרת היום */}
                <div style={styles.dayHeader}>{day}</div>
                
                <div style={styles.timeline}>
                  {dayActs.map((act, index) => (
                    <div key={act.id || index} style={styles.timelineItem}>
                      
                      {/* קו הנחש האנכי */}
                      <div style={styles.timelineLine} />
                      
                      {/* נקודת המפגש של הנחש */}
                      <div style={styles.timelineBadge} />
                      
                      {/* תיבת התוכן */}
                      <div style={styles.timelineContent}>
                        <div style={styles.contentHeader}>
                          <span style={styles.timelineText}>
                            {act.description || act.name}
                          </span>
                          <span style={styles.timelineTime}>
                            {act.iTime.substring(11, 16)}
                          </span>
{/*                           
                          <span style={styles.timelineTime}>
                            {act.iTime ? new Date(act.iTime).toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" }) : "-"}
                          </span> */}
                        </div>
                        
                        {act.name && act.description && (
                          <div style={styles.activityCode}>spName: {act.name}</div>
                        )}
                        
                        {/* הצגת מידע נוסף אם קיים */}
                        {/* {renderExtraData(act.extraData)} */}
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  );
};

const Info = ({ label, value }) => (
  <div style={styles.infoBox}>
    <div style={styles.label}>{label}</div>
    <div style={styles.value}>{value}</div>
  </div>
);

const styles = {
  page: {
    padding: "2rem",
    background: "#f6f8fb",
    minHeight: "100vh",
    direction: "rtl"
  },

  backBtn: {
    marginBottom: "1rem",
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    background: "white",
    cursor: "pointer"
  },

  card: {
    background: "white",
    borderRadius: "16px",
    padding: "2rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "2rem"
  },

  avatar: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#1f6feb",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "bold"
  },

  name: {
    margin: 0
  },

  username: {
    margin: 0,
    color: "#666"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem"
  },

  infoBox: {
    background: "#f9fafc",
    padding: "1rem",
    borderRadius: "12px",
    border: "1px solid #eee"
  },

  label: {
    fontSize: "12px",
    color: "#888",
    marginBottom: "6px"
  },

  value: {
    fontSize: "14px",
    fontWeight: "600"
  },

  center: {
    padding: "2rem",
    textAlign: "center"
  },

  /* עיצובים ששודרגו לחלוקת ימים וציר זמן יפה */
  dayHeader: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#4f566b",
    background: "#f1f3f9",
    padding: "4px 12px",
    borderRadius: "20px",
    display: "inline-block",
    marginBottom: "1rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
  },

  timeline: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    paddingRight: "15px",
  },

  timelineItem: {
    display: "flex",
    position: "relative",
    paddingBottom: "1.2rem",
    alignItems: "flex-start",
  },

  timelineLine: {
    position: "absolute",
    right: "4px",
    top: "10px",
    bottom: 0,
    width: "2px",
    background: "#e3e8ee",
  },

  timelineBadge: {
    position: "absolute",
    right: "0px",
    top: "8px",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#1f6feb",
    border: "2px solid white",
    boxShadow: "0 0 0 2px rgba(31, 111, 235, 0.2)",
    zIndex: 1,
  },

  timelineContent: {
    marginRight: "25px",
    background: "#fff",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid #e3e8ee",
    width: "100%",
    boxShadow: "0 2px 5px rgba(0,0,0,0.01)",
    transition: "transform 0.2s ease"
  },

  contentHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px"
  },

  timelineText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1a1f36",
  },

  timelineTime: {
    fontSize: "12px",
    color: "#a3acb9",
    fontWeight: "500"
  },

  activityCode: {
    fontSize: "12px",
    color: "#697386",
    marginTop: "2px"
  },

  timelineExtra: {
    fontSize: "12px",
    color: "#4f566b",
    background: "#f7fafc",
    padding: "6px 10px",
    borderRadius: "6px",
    marginTop: "8px",
    border: "1px dashed #e3e8ee",
    display: "flex",
    flexWrap: "wrap",
    gap: "5px"
  }
};

export default UserDetails;